import React from "react";
import { Container } from "@mui/material";
import { Page } from "~/layout";
import { UserDetails } from "./user-details";

export function UserDetailsPage({
  breadcrumbs,
}: {
  breadcrumbs?: React.ReactNode;
}) {
  return (
    <Page title="User Details">
      <Container fixed>
        {breadcrumbs}
        <UserDetails />
      </Container>
    </Page>
  );
}
